enum LayoutNodeType {
  ZONE = "zone",
  SINGLE = "single",
  SERIES = "series",
  SEQUENCE = "sequence"
}

export default LayoutNodeType;
